import type { IconNode } from '../types';

/**
 * @name copy-type
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHg9IjgiIHk9IjgiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik00IDE2Yy0xLjEgMC0yLS45LTItMlY0YzAtMS4xLjktMiAyLTJoMTBjMS4xIDAgMiAuOSAyIDIiIC8+CiAgPHBhdGggZD0iTTEyIDEzdi0xaDZ2MSIgLz4KICA8cGF0aCBkPSJNMTUgMTJ2NiIgLz4KICA8cGF0aCBkPSJNMTQgMThoMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/copy-type
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const copyType: IconNode = [
  ['rect', { width: '14', height: '14', x: '8', y: '8', rx: '2', key: 'oyuw8j' }],
  ['path', { d: 'M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2', key: 'zix9uf' }],
  ['path', { d: 'M12 13v-1h6v1', key: '13j3gl' }],
  ['path', { d: 'M15 12v6', key: '18bv57' }],
  ['path', { d: 'M14 18h2', key: 'o11ubl' }],
];

export default copyType;
